import React, { useState, useEffect, useRef } from 'react';

import { useHistory, useParams } from "react-router-dom";
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel'
import { acessos } from '../../../../services/acessosAdmin'
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';
import services from '../../../../services';
import {
    cadastrarUsuarioAdmin,
    atualizarUsuarioAdmin,
    detalheUsuarioAdmin,
    inativarUsuarioAdmin,
    ativarUsuario
} from '../../../../services/http/SellerAdminstradorService/usuarioAdminService'
import FormHelperText from '@material-ui/core/FormHelperText';
import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const AdministradorForm = () => {
    const history = useHistory();
    const stateSenhaRef = useRef();
    const { addSnackBar } = useSnackBar();
    const { userId } = useParams();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [senhaCorreta, setSenhaCorreta] = useState(true);
    stateSenhaRef.current = senhaCorreta;
    const [senhaFormatoCorreto, setSenhaFormatoCorreto] = useState(true);
    const [senha, setSenha] = useState("");
    const [usuario, setUsuario] = useState({
        nome: "",
        email: "",
        telefone: "",
        tipoAcesso: "",
        senha: "",
        receberNotificacao: false,
        id: "",
        ativo: false
    });

    const changeUsuario = (value, propertie) => {
        setUsuario((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const validarFomatoSenha = () => {
        var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        var passou = regularExpression.test(usuario?.senha)
        setSenhaFormatoCorreto(passou);

        if (senha != usuario.senha) {
            setSenhaCorreta(false);
            return false;
        }
        setSenhaCorreta(true);
        stateSenhaRef.current = true;
        return true;
    }

    const setConfirmarSenha = (value) => {
        setSenha(value);
        setSenhaCorreta(true);
        if (value != usuario.senha) {
            setSenhaCorreta(false);
        }
    }

    const conferirSenha = () => {
        if (!(!usuario.senha && userId)) {
            return validarFomatoSenha();
        }

        return true;
    }

    const carregarDetalhesUsuarioAdmin = () => {
        trackPromise(
            detalheUsuarioAdmin(userId)
                .then(res => {
                    if (res.data) {
                        setUsuario(res.data);
                    } else {
                        if (userId) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do usuário', info: 'warning', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do usuário', info: 'error', open: true });
                })
        )
    }

    const inativarUsuario = () => {
        if (userId != null || userId != undefined) {
            trackPromise(
                inativarUsuarioAdmin(userId)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Usuário inativado com sucesso', info: 'success', open: true });
                            history.push(`/admin/administradores`)
                        } else {
                            addSnackBar({ message: 'Não foi inativar usuário', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar usuário', info: 'error', open: true });
                    })
            )
        }
    }

    const ativarUsuarioAdmin = () => {
        if (userId != null || userId != undefined) {
            trackPromise(
                ativarUsuario(userId)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Usuário ativo', info: 'success', open: true });
                            history.push(`/admin/administradores`)
                        } else {
                            addSnackBar({ message: 'Não foi ativar usuário', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao ativar usuário', info: 'error', open: true });
                    })
            )
        }
    }

    const submitUsuarioAdmin = () => {
        if (!validarForm() && conferirSenha()) {
            removerMascaraTelefone();
            if (userId == null || userId == undefined) {
                trackPromise(
                    cadastrarUsuarioAdmin(usuario)
                        .then(res => {
                            if (res.data != null && res.data != false) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                history.push(`/admin/administradores`);
                                /* history.push(`/admin/administrador/${res.data}`) */
                            } else {
                                /*  addSnackBar({ message: 'Não foi possível cadastrar usuário', info: 'error', open: true }); */
                                //alert(JSON.stringify(res.errors));
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            //alert(JSON.stringify(error));
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar usuário', info: 'error', open: true });
                        })
                )
            }
            else {
                usuario.id = userId;
                trackPromise(
                    atualizarUsuarioAdmin(usuario)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Usuário atualizado com sucesso', info: 'success', open: true });
                            } else {
                                //alert(JSON.stringify(res));
                                //alert(telefone.length);
                                //alert(usuario.telefone.toString().length);
                                if(usuario.telefone.toString().length <= 10){
                                    addSnackBar({ message: 'Não foi possível editar usuário-Telefone menor que dez digítos', info: 'error', open: true });
                                }else
                                addSnackBar({ message: 'Não foi possível editar usuário', info: 'error', open: true });
                            }
                        }).catch(error => {
                            //alert('teste');
                            addSnackBar({ message: 'Erro ao editar usuário', info: 'error', open: true });
                        })
                )
            }

        }
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!usuario?.nome) isInvalidForm = true;
        if (!usuario?.email) isInvalidForm = true;
        if (usuario?.senha?.length < 8) isInvalidForm = true;
        if (!usuario?.telefone) isInvalidForm = true;
        if (!stateSenhaRef) isInvalidForm = true;
        if (!usuario?.tipoAcesso) isInvalidForm = true;

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const removerMascaraTelefone = () => {
        if (usuario?.telefone.includes("(")) {
            usuario.telefone = services.mask.unMask(usuario?.telefone);
        }
    }

    const msgSenha = () => {
        if (isFormInvalid && usuario?.senha.length < 8) {
            return 'Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123';
        } else if (!senhaFormatoCorreto) {
            return 'Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123';
        }
    }

    useEffect(() => {
        if (userId != null) {
            carregarDetalhesUsuarioAdmin(userId);
        }
    }, []);

    const verifyAcesso = () => {
        if (isFormInvalid && usuario?.tipoAcesso == "") {
            return (<FormHelperText>Campo obrigatório</FormHelperText>);
        }
    }

    return (
        <div>

            <div className='row mt20'>
                <span className="col-sm-3 col-md-3 col-lg-3 titulo mt20">Administradores</span>
            </div>

            <div className='row negative-margin ml-1'>
                <strong>Detalhe</strong>
            </div>
            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Dados de Acesso</h1>
            </div>

            <div className="row mt20">
                <div className='col-md-5 col-md-5 col-lg-5'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Nome"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'nome')}
                            value={usuario?.nome || ''}
                            helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-4 col-md-4 col-lg-4'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="E-mail"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'email')}
                            value={usuario?.email || ''}
                            helperText={isFormInvalid && !usuario?.email && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.email ? true : false} />
                    </FormControl>
                </div>

                <div className="col-md-3 col-sm-3 col-lg-3">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Acesso</InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            value={usuario?.tipoAcesso || 'selecione'}
                            label="Acesso"
                            onChange={event => changeUsuario(event.target.value, 'tipoAcesso')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Acesso</em>
                            </MenuItem>

                            {acessos.map(acesso =>
                                <MenuItem value={acesso}>{acesso}</MenuItem>
                            )}
                        </Select>

                        {
                            verifyAcesso()
                        }
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className='col-md-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Celular"
                            size="small"
                            inputProps={{ maxLength: 15 }}
                            onChange={event => changeUsuario(services.mask.phoneoucelularuser(event.target.value), 'telefone')}
                            value={services.mask.phoneoucelularuser(usuario?.telefone) || ''}
                            helperText={isFormInvalid && !usuario?.telefone && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.telefone ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-3 col-md-3 col-lg-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Senha"
                            type="password"
                            size="small"
                            onChange={event => changeUsuario(event.target.value.trim(), 'senha')}
                            value={usuario?.senha || ''}
                            helperText={msgSenha()}
                            error={isFormInvalid && usuario?.senha.length < 8 ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-3 col-md-3 col-lg-3'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Confirmar Senha"
                            type="password"
                            size="small"
                            onChange={(event) => setConfirmarSenha(event.target.value)}
                            defaultValue={''}
                            helperText={!senhaCorreta ? "A senha não esta igual" : ""}
                            error={!senhaCorreta && isFormInvalid ? true : false} />
                    </FormControl>
                </div>

                <div className='col-md-3'>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Receber Notificações</FormLabel>
                        <RadioGroup className="radio-notify" value={usuario.receberNotificacao ? "sim" : "nao"} row aria-label="notificacoes" name="row-radio-buttons-group">
                            <FormControlLabel onChange={() => changeUsuario(true, 'receberNotificacao')} value={usuario.receberNotificacao ? "sim" : "sim"} control={<Radio />} label="Sim" />
                            <FormControlLabel onChange={() => changeUsuario(false, 'receberNotificacao')} value={!usuario.receberNotificacao ? "nao" : "nao"} control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>

            {/* se for editar exibe botão inativo */}
            {userId &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitUsuarioAdmin()}>SALVAR</button>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => history.push(`/admin/administradores`)}>CANCELAR</button>
                        {usuario?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarUsuario} >INATIVAR</button>}
                        {!usuario?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarUsuarioAdmin} >ATIVAR</button>}

                    </div>

                </div>}

            {!userId &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={() => submitUsuarioAdmin()}>SALVAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => history.push(`/admin/administradores`)}>CANCELAR</button>
                    </div>

                </div>}



        </div>
    );
}

export default AdministradorForm;